import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	orgSettings: {},
	personSettings: {},

	mergedOrgSettings: {},
	mergedPersonSettings: {},

	orgSettingsLoading: false,
	personSettingsLoading: false,
	orgSettingsLoadingComplete: false,
	personSettingsLoadingComplete: false,

	selectedSettingGroupID: false,
	error: null,

	upsertOrgSettingsLoading: false,
	upsertPersonSettingsLoading: false,
	upsertError: null
};

const settingsSlice = createSlice({
	name: 'settings',
	initialState,
	reducers: {
		// ── Load (existing) ────────────────────────────────────────────────
		loadOrgSettings: (state) => {
			state.orgSettingsLoading = true;
			state.error = null;
		},
		loadOrgSettingsSuccess: (state, action) => {
			state.orgSettings[action.payload.orgID] = action.payload.settings;
			state.orgSettingsLoading = false;
			state.orgSettingsLoadingComplete = true;
		},
		loadOrgSettingsError: (state, action) => {
			state.orgSettingsLoading = false;
			state.error = action.payload;
		},
		loadPersonSettings: (state) => {
			state.personSettingsLoading = true;
			state.error = null;
		},
		loadPersonSettingsSuccess: (state, action) => {
			state.personSettings[action.payload.personID] = action.payload.settings;
			state.personSettingsLoading = false;
			state.personSettingsLoadingComplete = true;
		},
		loadPersonSettingsError: (state, action) => {
			state.personSettingsLoading = false;
			state.error = action.payload;
		},
		mergeOrgSettings: (state, action) => {
			state.mergedOrgSettings[action.payload.orgID] = action.payload.mergedSettings;
		},
		mergePersonSettings: (state, action) => {
			state.mergedPersonSettings[action.payload.personID] = action.payload.mergedSettings;
		},

		upsertOrgSettings: (state) => {
			state.upsertOrgSettingsLoading = true;
			state.upsertError = null;
		},
		upsertOrgSettingsSuccess: (state) => {
			state.upsertOrgSettingsLoading = false;
		},
		upsertOrgSettingsError: (state, action) => {
			state.upsertOrgSettingsLoading = false;
			state.upsertError = action.payload;
		},

		upsertPersonSettings: (state) => {
			state.upsertPersonSettingsLoading = true;
			state.upsertError = null;
		},
		upsertPersonSettingsSuccess: (state) => {
			state.upsertPersonSettingsLoading = false;
		},
		upsertPersonSettingsError: (state, action) => {
			state.upsertPersonSettingsLoading = false;
			state.upsertError = action.payload;
		},

		// ── Person setting (legacy — existing) ─────────────────────────────
		updatePersonSetting: () => {},
		updatePersonSettingError: (state, action) => {
			state.error = action.payload;
		},
		// ! Deprecated. DO NOT USE THIS ACTION ANYMORE. Use setSelectedSettingGroup instead.
		updateSelectedSettingGroup(state, action) {
			state.selectedSettingGroupID = action.payload;
		},
		setSelectedSettingGroup(state, action) {
			state.selectedSettingGroupID = action.payload;
		}
	},
	extraReducers: (builder) => {
		builder.addCase('auth/logout', () => initialState);
	}
});

export const settingsActions = settingsSlice.actions;
export default settingsSlice.reducer;
